export default __webpack_public_path__ + "static/educaCiencia-ac572bad90c066be085a1a4395a6f4e8.jpeg";